import IconButton from "@mui/material/IconButton"
import { styled } from "@mui/material/styles"

export const StyledDiv = styled("div")({
  position: "absolute",
  bottom: 15,
  left: 15,
  zIndex: 999,
  background: "rgba(255, 255, 255, 0.5)",
  borderRadius: "3px",
  padding: "5px 0px 5px 18px",
  boxShadow: "4px 4px 10px 8px rgba(0, 0, 0, 0.09)"
})

export const StyledIconButton = styled(IconButton)({
  marginRight: "16px",
  color: "rgb(33, 39, 55)"
})
